module.exports = __webpack_public_path__ + "static/media/user-profile.12a456dd.svg";